import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './element/element.js'
import VueScrollReveal from 'vue-scroll-reveal'
import 'lib-flexible/flexible.js'

Vue.use(VueScrollReveal,{
  class: 'v-scroll-reveal',  
  duration: 1000,
  scale: 1,
  distance: '0px',
  reset:true,
  mobile: false,
  useDelay: 'always',
  origin:'top',
  delay: 200
  }); 

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
